import { defineComponent as _defineComponent } from 'vue'
import {reactive, ref, computed, watch} from 'vue';
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryCsvDownloadButtonNew',
  props: {
  periodBegin: {type: String, default: ''},
  periodEnd: {type: String, default: ''},
  state: {type: String, default: null},
  id: {type: [String, Number], default: null},
  accountNumber: {type: String, default: ''},
  textSearch: {type: String, default: ''},
},
  setup(__props) {

const props = __props;

const loadingStatus = reactive(new RemoteRequestState())



const formingCsv = computed(() => loadingStatus.isLoading)

const loadedCsv = computed(() => href.value !== '#')

const forceDownload = () => {
  window.open(href.value, '_self');
}

const reqId = ref(props.id ? props.id : new Date().getTime())

const formingCsvProgress = ref(0)

const href = ref('#')

const downloadCsv = () => {
  if (href.value !== '#') {
    forceDownload();
    return;
  }
  loadCsvFile();
}


const resultCsv = ref([])

const errorMessage = ref('')
const doError = (error) => {
  loadingStatus.loadError();
  errorMessage.value = error ?? 'Error loading CSV file.';
}

const getBom = () => {
  const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
  return URL.createObjectURL(new Blob([bom], {type: 'application/octet-stream'}));
}

const getBase64DataUrl = (data, headers = '') => {
  return `data:application/octet-stream;base64,${
    btoa(unescape(encodeURIComponent(`${headers}\n${data}`)))}`
}

const requestKey = computed(() => {
  return [
    props.periodBegin,
    props.periodEnd,
    props.state,
    reqId.value,
    props.textSearch,
    props.accountNumber,
  ].join(':');
})

watch(() => requestKey.value, (val) => {
  if (loadingStatus.isLoading) {
    loadingStatus.loadEnd();
  }
  href.value = '#';
  formingCsvProgress.value = 0;
  resultCsv.value = [];
})

const loadCsvFile = async () => {
  if (loadingStatus.isLoading) {
    return;
  }
  const key = requestKey.value;

  let errorCounter = 5;
  let csv = [];
  resultCsv.value = [];
  let response = null;
  href.value = '#';
  loadingStatus.loadStart();

  try {
    do {
      try {
        if (key !== requestKey.value) {
          return;
        }
        response = await httpAxiosApi.post(
          '/webapi/finance/history/LoadCsvPage', {
            call: 'LoadCsvPage',
            from: props.periodBegin,
            to: props.periodEnd,
            state: props.state,
            id: reqId.value,
            textSearch: props.textSearch,
            accountNumber: props.accountNumber,
            pagesize: 200
          });
        if (key !== requestKey.value) {
          return;
        }
        formingCsvProgress.value = Math.round(
          response.data.totalPages === 0 ? 100 :
          (response.data.loadedPages / response.data.totalPages * 100))
        csv = [...csv, response.data.csv];
        if (response.data.url) {
          href.value = response.data.url;
        }
      } catch (error) {
        console.error(error)
        errorCounter--;
      }
    } while (!response.data.url && errorCounter > 0);

    if (errorCounter === 0) {
      throw new Error('Error loading CSV file.');
    }

    forceDownload();
  } catch (error) {
    doError(error);
  }
}


return { __sfc: true,loadingStatus, props, formingCsv, loadedCsv, forceDownload, reqId, formingCsvProgress, href, downloadCsv, resultCsv, errorMessage, doError, getBom, getBase64DataUrl, requestKey, loadCsvFile, reactive, ref, computed, watch, httpAxiosApi, RemoteRequestState }
}

})